export const FACEBOOK_MESSENGER_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
].join(',');
